import { render } from "./SVGDefs.vue?vue&type=template&id=3e87ffd8"
const script = {}

import exportComponent from "/Users/veerle/public_html/local/societaslinguistica/app/public/wp-content/plugins/sle-schedule/vuejs_app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__